import { useEffect } from "react";

function getAnswers(tcpaData) {
  tcpaData.templateCols = tcpaData.templateCols || 2
  tcpaData.templateRows = tcpaData.templateRows || 2

  const baseAnswers = tcpaData.answers || []
  const allAnswers = (tcpaData.skipOption && tcpaData.skipAnswer && !tcpaData.isMultipleAnswers)
    ? [...baseAnswers, tcpaData.skipAnswer]
    : baseAnswers

  if (tcpaData.templateType === 'only-dropdown') {
    return { options: allAnswers }
  }

  if (tcpaData.templateType === 'only-buttons') {
    return {
      rows: !allAnswers.length ? [] : allAnswers.reduce((acc, answer, index) => {
        const row = Math.floor(index / tcpaData.templateCols);
        if (!acc[row]) acc[row] = [];
        acc[row].push({ ...answer, index });
        return acc;
      }, []),
    }
  }

  const firstAnswers = allAnswers.slice(0, tcpaData.templateCols * tcpaData.templateRows)
  const options = allAnswers.slice(tcpaData.templateCols * tcpaData.templateRows)
  const rows = firstAnswers.reduce((acc, answer, index) => {
    const row = Math.floor(index / tcpaData.templateCols);
    if (!acc[row]) acc[row] = [];
    acc[row].push({ ...answer, index });
    return acc;
  }, [])

  return { rows, options }
}

function initStateBlocks({ tcpaData, rootScope }) {
  tcpaData.blocks = {
    block: 'root-page',
    scope: rootScope,
    blocks: [{
      block: 'button-and-dropdown-container',
      scope: rootScope,
      blocks: [],
    },
    ],
  }

  const newBlocks = { ...tcpaData.blocks };
  newBlocks.blocks[0].blocks = [];

  return newBlocks
}

export default function useButtonAndDropdownState({ tcpaData, onChange, disabled }) {
  const {
    consentTextActive,
    consentPosition,
    leadid,
    trustedform,
    css,
    cfid,
    consentText,
    question,
    trustedform_cfid,
    leadid_cfid,
    manualSubmit,
    required,
    templateCols,
    answers,
    isMultipleAnswers,
    templateType,
    buttonPadding,
    horizontalPadding,
    saveConsentText,
    autoScrollToConsent,
    skipAnswer,
    skipOption,
  } = tcpaData

  useEffect(() => {
    if (!disabled) {
      const { rows, options } = getAnswers(tcpaData)

      const rootScope = {
        cfid: cfid,
        rows_answers: rows,
        answers_dropdown: options,
        consentText: consentText,
        question: question,
        trustedformCfid: trustedform_cfid,
        leadidCfid: leadid_cfid,
        manualSubmit: manualSubmit || false,
        required: required || false,
        isMultipleAnswers: templateType === 'only-buttons' ? isMultipleAnswers : false,
        autoScrollToConsent: autoScrollToConsent || false,
        templateType,
        buttonPadding,
        horizontalPadding,
        leadid,
        saveConsentText,
      }

      const newBlocks = initStateBlocks({ tcpaData, rows, options, rootScope })

      newBlocks.blocks[0].blocks.push({
        block: 'title',
        scope: {},
      });

      if (consentTextActive && consentPosition === "before") {
        newBlocks.blocks[0].blocks.push({
          block: 'consent',
          scope: {},
        });
      }

      newBlocks.blocks[0].blocks.push({
        block: 'button-and-dropdown-answers',
        scope: {},
      })

      if (consentTextActive && consentPosition === "after") {
        newBlocks.blocks[0].blocks.push({
          block: 'consent',
          scope: {},
        });
      }

      if (trustedform) {
        newBlocks.blocks[0].blocks.push({
          block: 'trusted-form',
          scope: {},
        });
      }

      newBlocks.blocks[0].blocks.push({
        block: 'style',
        scope: {
          css: css,
        },
      });

      onChange('blocks', newBlocks)
    }
  }, [
    answers,
    consentTextActive,
    consentPosition,
    leadid,
    trustedform,
    css,
    cfid,
    consentText,
    question,
    trustedform_cfid,
    leadid_cfid,
    manualSubmit,
    required,
    templateCols,
    templateType,
    isMultipleAnswers,
    disabled,
    buttonPadding,
    horizontalPadding,
    tcpaData,
    onChange,
    saveConsentText,
    skipAnswer,
    skipOption,
  ])
}
